import API from "../API";

export async function jyskFetch(path, body = {}) {
  const response = await fetch(`${API.SERVER_ADDRESS}jysk/${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${API.token || localStorage.getItem("bearerToken") || ""}`,
    },
    body: JSON.stringify(body),
  });
  const data = await response.json();
  if (!response.ok || data.error)
    throw new Error(data.message || "İşlem tamamlanamadı.");
  return data;
}
export const ref = (value) =>
  String(value || "")
    .slice(-6)
    .toUpperCase();
export const money = (value) =>
  Number(value || 0).toLocaleString("tr-TR", {
    style: "currency",
    currency: "TRY",
  });
export const date = (value) =>
  value ? new Date(value).toLocaleString("tr-TR") : "—";
export const services = {
  immediate: "Hemen",
  scheduled: "Planlı",
  flexible: "Esnek",
};
export const statuses = {
  arrived_pickup: "İlk adrese varıldı",
  arrived_intermediate: "Ara durağa varıldı",
  arrived_delivery: "Teslimat adresine varıldı",
  "-1": "İptal Edildi",
  0: "Sürücü Bekleniyor",
  1: "Sürücü Bulundu",
  2: "Sürücü Yolda",
  3: "Teslimat Tarihi Onaylandı",
  4: "Teslimat Devam Ediyor",
  10: "Tamamlandı",
  stock_pending: "Stok Bekleniyor",
  stock_arrived: "Stok Geldi",
  order_created: "Sipariş Oluşturuldu",
  cancelled: "İptal Edildi",
  delivered: "Teslim Edildi",
  awaiting_payment: "Ödeme Bekleniyor",
  overdue: "Vadesi Geçti",
  paid: "Ödendi",
  sending: "Gönderiliyor",
  sent: "Gönderildi",
  delivered_sms: "İletildi",
  failed: "Gönderilemedi",
  unknown: "Gönderim Durumu Bekleniyor",
};
export const payer = (value) =>
  value === "account" ? "JYSK Hesabı" : "Müşteri Ödemeli";
export function downloadCsv(name, headers, rows) {
  const cell = (v) =>
    `"${String(v ?? "")
      .replace(/^[=+@-]/, "'$&")
      .replace(/"/g, '""')}"`;
  const blob = new Blob(
    [
      "\uFEFF" +
        [headers, ...rows].map((row) => row.map(cell).join(";")).join("\r\n"),
    ],
    { type: "text/csv;charset=utf-8" },
  );
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${name}.csv`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
